<script>

    import { toast } from 'bulma-toast'
    import { modalStore, prepaidsStore, prepaidStore } from '../stores'

    import Providers from '../$components/providers.svelte'
    import PrepaidsService from '../$services/prepaids.service.js'

    import Form from '../$components/form.svelte'

    import InputText from '../$components/input.text.svelte'
    import InputNumber from '../$components/input.number.svelte'

    import ButtonModal from '../$components/button.modal.svelte'
    import ButtonSave from '../$components/button.save.svelte'

    let data = new Object({
        _id: $prepaidStore._id,
        provider: $prepaidStore.provider,
        service: $prepaidStore.service,
        volumetricMin: $prepaidStore.volumetricMin,
        volumetricMax: $prepaidStore.volumetricMax,
        shipmentPrice: $prepaidStore.shipmentPrice,
        shipmentsTotal: $prepaidStore.shipmentsTotal,
        coverageSpecial: $prepaidStore.coverageSpecial || 0,
        coverageCost: $prepaidStore.coverageCost || 0,
    })
    
    let loading = false

    async function updatePrepaid() {

        loading = true
        const resp = await PrepaidsService.updatePrepaid(data._id, data)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        prepaidsStore.replace(resp.data)
        prepaidStore.set(resp.data)

        toast({message: 'Prepago actualizado', type: 'is-success'})
        
        modalStore.set('prepaid_modal')
    }

</script>

<Form on:submit={updatePrepaid} { loading }>

    <Providers bind:provider={data.provider} bind:service={data.service} />

    <div class="columns">
        <div class="column">
            <InputText bind:value={data.volumetricMin} label="Peso mínimo" placeholder="Peso mínimo (kg)" />
        </div>
        <div class="column">
            <InputText bind:value={data.volumetricMax} label="Peso máximo" placeholder="Peso máximo (kg)" />
        </div>
    </div>

    <div class="columns">
        <div class="column">
            <InputNumber bind:value={data.shipmentPrice} step="0.01" label="Precio de envío" placeholder="Precio de envío" />
        </div>
        <div class="column">
            <InputNumber bind:value={data.shipmentsTotal} label="Cantidad de guías" placeholder="Cantidad de guías" />
        </div>
    </div>

    <div class="columns">
        <div class="column">
            <InputNumber bind:value={data.coverageCost} step="0.01" label="Cobertura costo" placeholder="Cobertura costo" />
        </div>
        <div class="column">
            <InputNumber bind:value={data.coverageSpecial} step="0.01" label="Cobertura especial" placeholder="Cobertura especial" />
        </div>
    </div>

    <div class="is-flex is-justify-content-flex-end is-align-items-center">
        <ButtonModal modalId="prepaid_modal" text="Cancelar" icon="ban" />
        <ButtonSave icon="edit" text="Actualizar" { loading } />
    </div>

</Form>